import { Interval } from 'luxon';

export type ReservationWithHeadcount = {
  interval: Interval;
  eventType: string | null;
  headcount: number;
};

export type IntervalHeadcountCount = {
  interval: Interval;
  count: number;
  eventType: string | null;
};

export enum ReservableAvailabilityReason {
  Full = 'Full',
  UserCapReached = 'UserCapReached',
}

export type AvailabilityInterval = {
  startDate: Date;
  endDate: Date;
  eventType: string | null;
  remainingSpots: number;
  reason: ReservableAvailabilityReason | null;
};
